/**
 * @param params setters from Format
 */
export function setConfigR54(params) {
    const { setHeaders, setPdfConfig, setExcelConfig, setHtmlConfig, setData, filter } = params;
    const headers = [
        "PROGRAMAS Y PROYECTOS",
    ]
    setHeaders(headers)
    const tempData = {
        action: "reporteProgramasyProyectos",
        year: (new Date(filter.year)).getFullYear(),
    }
    setData(tempData);
    setHtmlConfig({
        headers,
    })
    setPdfConfig({
        descr: tempData,
        headers,
    });
    setExcelConfig({
        headers,
    });
}